import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

import * as styles from './Head.css';
import { Logo } from '../Logo';

export interface IHeadProps {
  phoneButton: React.ReactNode;
  callbackButton?: React.ReactNode;
  breadcrumbs: React.ReactNode;
  logo: string;
  name: string;
}

export const Head: React.FC<IHeadProps> = ({ phoneButton, callbackButton, logo, name, breadcrumbs }) => {
  return (
    <div className={styles['background']}>
      <div className={styles['container']}>
        {breadcrumbs}
        <div className={styles['main-block']}>
          <div className={styles['main-block-content']}>
            <Logo img={logo} size={{ phone: 60, tablet: 60, desktop: 80 }} />
            <h1 className={styles['title']}>
              <span className={styles['title-builder']}>Строительная компания</span>
              <Responsive desktop>
                <div className={styles['offset']} />
              </Responsive>
              <span className={styles['title-name']}>{name}</span>
            </h1>
          </div>
          <Responsive desktop>
            <div className={styles['actions']}>
              {phoneButton}
              {callbackButton}
            </div>
          </Responsive>
        </div>
      </div>
    </div>
  );
};
